import { initAssetServer } from './__webpack_public_path__';

initAssetServer();
import { defineCustomElement } from 'vue';

import App from './App.ce.vue';

import { defineCustomElement as defineCustomElementFootnoteReference } from '@dh-io-emh/footnotes/dist/components/emh-footnote-reference';
import {
  applyPolyfills,
  defineCustomElements as defineCustomElementsPriceDisplay,
} from '@dh-io-pls/price-display/dist/loader';
import { defineCustomElements as defineCustomElementsFcisWidget } from 'fcis-widget/dist/loader';

window.customElements.define('emh-stage-campaign-item', defineCustomElement(App));

applyPolyfills()
  .then(() => {
    defineCustomElementFootnoteReference();
    defineCustomElementsPriceDisplay(window);
    defineCustomElementsFcisWidget(window);
  })
  .catch(() => console.error('Failed to load Stencil polyfills'));
